<!--
   Created by qing on 2020/3/3 6:08 下午
   Des:
-->
<template>
  <div class="form-data-view-container">

    <div class="form-view-data-popup-container" v-if="formSet.isInit && !btnId">


      <div class="archive-status" v-if="archiveStatus && archiveStatus === 'YES'">
        <svg t="1625284754439" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="1370" width="44" height="44">
          <path
            d="M936.999 234.579C782.773 0.151 467.589-65.027 232.933 89.043c-234.657 154.07-299.9 468.951-145.68 703.379 154.221 234.422 469.42 299.606 704.067 145.537 234.646-154.07 299.9-468.952 145.679-703.38zM768.373 903.238c-215.487 141.477-504.865 81.556-646.477-133.635C-19.7 554.326 40.281 265.236 255.666 123.764 471.158-17.703 760.532 42.218 902.138 257.398c141.604 215.18 81.722 504.368-133.765 645.84z m108.641-629.372C744.54 72.574 473.844 16.626 272.354 148.867 70.865 281.109 14.76 551.65 147.228 752.936c132.372 201.298 403.176 257.344 604.659 125 201.495-132.344 257.595-402.778 125.127-604.07zM740.467 860.685c-191.95 125.993-449.843 72.712-575.96-119.06C38.389 549.861 91.718 292.221 283.672 166.227c191.956-125.994 449.849-72.718 575.966 119.05 126.216 191.766 72.79 449.408-119.171 575.408z m-349.048-530.57c60.479-39.683 133.368-45.637 196.425-22.519l21.737-14.289c-72.387-31.946-158.883-27.68-229.984 18.942-71.1 46.627-109.23 124.308-108.636 203.375l21.748-14.387c3.772-67.053 38.232-131.438 98.71-171.122z m253.125 384.626c71.096-46.627 109.231-124.313 108.636-203.375l-21.742 14.29c-3.768 67.069-38.231 131.45-98.709 171.133-60.474 39.688-133.364 45.627-196.42 22.524l-21.747 14.386c72.384 31.937 158.887 27.67 229.982-18.958zM326.868 293.408l14.796-39.089 41.71 1.986-32.574-26.09 14.797-39.089-34.954 22.92-32.674-26.095 11.023 40.277-34.952 22.915 41.801 1.986 11.027 40.279z m-40.216 41.274l-40.617-9.824-3.077-41.665-21.95 35.513-40.611-9.916 27.01 31.943-21.946 35.518 38.629-15.874 27.111 31.845-3.178-41.669 38.629-15.871z m150.647-98.813l29.888-29.168 37.043 19.349-18.473-37.401 29.888-29.168-41.406 6.05-18.473-37.499-7.052 41.171-41.405 6.055 37.037 19.44-7.047 41.171z m124.429-5.556l39.513-13.787 25.328 33.136-0.997-41.669 39.528-13.888-40.124-12.005-0.895-41.664-23.827 34.324-40.016-12.004 25.311 33.232-23.821 34.325zM191.222 454.819l-20.456-36.407-4.866 41.465-41.015 8.138 37.933 17.459-4.866 41.466 28.403-30.651 37.932 17.459-20.456-36.407 28.403-30.758-41.012 8.236z m506.055 278.682L682.48 772.58l-41.709-1.986 32.572 26.094-14.795 39.09 34.957-22.916 32.675 26.08-11.023-40.268 34.948-22.919-41.807-1.986-11.021-40.268z m141.412-82.846l-38.635 15.874-27.111-31.85 3.178 41.674-38.629 15.875 40.617 9.818 3.076 41.66 21.947-35.514 40.622 9.922-27.017-31.943 21.952-35.516z m-251.843 140.38l-29.888 29.168-37.042-19.35 18.473 37.408-29.888 29.163 41.409-6.06 18.469 37.505 7.047-41.162 41.41-6.064-37.032-19.435 7.042-41.173z m-124.423 5.553l-39.524 13.791-25.323-33.136 0.992 41.67-39.524 13.888 40.119 12.01 0.896 41.658 23.832-34.323 40.021 11.997-25.323-33.227 23.834-34.328zM861.332 541.43l4.866-41.472-28.407 30.656-37.934-17.459 20.457 36.411-28.403 30.744 41.019-8.225 20.451 36.408 4.867-41.467 41.014-8.133-37.93-17.463z"
            fill="#19be6b" p-id="1371"></path>
          <path
            d="M375.298 584.906l-23.565-36.422-72.389 46.838c-2.72 1.76-4.606 3.483-5.663 5.164l-6.729-4.436c2.442-0.863 5.122-2.242 8.045-4.133l72.691-47.033-0.489-8.045c-0.036-2.262 0.476-3.738 1.534-4.423 1.057-0.685 3.35-0.952 6.875-0.805l10.082 0.339c3.093 0.142 5.047 0.844 5.861 2.102 0.816 1.262-0.338 3.9-3.453 7.916l21.414 33.097c1.826 2.821 3.213 4.856 4.16 6.099l2.596 3.68c0.652 1.01 0.71 2.258 0.173 3.748-0.535 1.492-2.025 3.883-4.468 7.178-2.441 3.296-3.99 5.154-4.645 5.578-0.656 0.424-1.438-0.068-2.352-1.48l-6.159-9.521-62.716 40.579 31.583 48.813c1.955 3.022 3.978 4.606 6.075 4.751 2.095 0.146 7.721-2.424 16.881-7.707 9.158-5.282 17.844-10.58 26.057-15.895 8.21-5.312 15.744-10.4 22.602-15.266 6.855-4.865 10.867-7.998 12.036-9.396 1.167-1.396 1.841-3.119 2.019-5.164s-0.195-4.662-1.115-7.855c-0.921-3.188-2.475-7.188-4.653-11.996-2.183-4.806-5.281-11.195-9.298-19.174l4.08-2.641c5.826 9.666 10.959 16.887 15.404 21.654 4.445 4.772 8.701 6.986 12.766 6.641 2.334-0.367 3.828-0.048 4.48 0.961 0.65 1.006 0.856 4.089 0.622 9.246-0.239 5.154-1.651 9.322-4.241 12.498-2.59 3.177-8.883 8.139-18.877 14.894-9.995 6.753-22.449 14.954-37.359 24.601-14.911 9.648-25.297 15.796-31.157 18.445-5.864 2.648-10.981 3.96-15.356 3.934-4.379-0.027-8.717-3.365-13.02-10.014l-39.014-60.3c-4.434-6.851-8.234-12.394-11.405-16.632 7.964-3.15 13.921-5.326 17.864-6.521 3.944-1.191 6.145-1.436 6.6-0.732 0.587 0.907-0.498 3.539-3.254 7.895l6.16 9.521 62.717-40.581zM424.673 508.795c-2.935-4.534-5.643-8.497-8.125-11.895 4.111-1.374 9.105-2.709 14.982-4.013 5.877-1.299 9.107-1.497 9.694-0.591 0.587 0.907-0.517 3.624-3.308 8.143l37.549 58.032c3.26 5.039 5.591 8.533 6.996 10.48l3.92 5.396c0.391 0.605 0.244 1.594-0.44 2.965-0.685 1.375-2.079 3.525-4.183 6.459-2.104 2.935-3.533 4.643-4.289 5.132s-1.459 0.231-2.111-0.777l-4.587-7.752c-1.726-2.884-4.542-7.351-8.454-13.396l-37.644-58.183z m11.219-46.279c9.4-3.365 15.635-5.326 18.704-5.885 3.07-0.556 4.817-0.507 5.24 0.147 0.425 0.657 0.175 1.816-0.747 3.485-0.923 1.669-1.183 3.09-0.782 4.258 0.4 1.172 1.267 2.899 2.601 5.178 22.009 35.787 35.414 58.877 40.215 69.277 4.8 10.4 7.744 20.254 8.83 29.553 1.088 9.303 0.25 18.669-2.507 28.101-2.762 9.431-7.146 19.663-13.153 30.7l-3.076-1.44c5.513-16.001 7.91-29.526 7.197-40.567-0.712-11.043-3.618-22.491-8.715-34.345-5.096-11.852-16.02-30.725-32.774-56.619-5.998-9.268-13.01-19.883-21.033-31.843z m114.541 24.938l-38.536 24.934c-1.813 1.173-3.538 3.147-5.175 5.921l-6.826-4.587c2.442-0.864 5.121-2.243 8.045-4.134l40.047-25.912-23.564-36.42-42.013 27.183c-2.72 1.76-4.606 3.483-5.662 5.165l-7.12-5.04c2.442-0.864 5.121-2.242 8.045-4.133l41.861-27.086 0.285-9.832c-0.047-1.396 0.23-2.293 0.834-2.685 0.907-0.587 4.229-0.806 9.971-0.662 5.739 0.146 9.348 0.313 10.828 0.498 1.479 0.189 2.496 0.71 3.049 1.565 0.555 0.857-0.756 4.026-3.926 9.507l49.38 76.318c2.934 4.533 5.134 7.826 6.604 9.876l3.965 5.796c0.391 0.605 0.533 1.156 0.427 1.654-0.106 0.497-0.714 1.711-1.823 3.645-1.108 1.93-2.485 4-4.129 6.209-1.646 2.208-2.77 3.507-3.374 3.897-0.604 0.392-1.429-0.221-2.472-1.831l-8.115-12.543-49.719 32.17c-2.721 1.761-4.608 3.48-5.663 5.164l-6.925-4.738c2.441-0.863 5.121-2.24 8.045-4.133l51.23-33.147-27.574-42.619zM607.567 406.107l2.268-1.467 0.027-9.236c0.061-1.895 0.542-3.138 1.449-3.725 0.906-0.586 4.213-0.223 9.92 1.085 5.706 1.313 8.822 2.368 9.342 3.173 0.523 0.808-0.176 1.83-2.088 3.067l-17.984 11.636 10.756 16.624c8.244-1.616 14.883-2.233 19.922-1.849 5.037 0.386 8.421 1.915 10.146 4.583 1.729 2.67 2.403 5.702 2.023 9.09-0.379 3.391-1.25 5.525-2.609 6.405-1.359 0.879-2.627 1.023-3.801 0.422-1.173-0.599-2.83-1.777-4.969-3.538-6.287-5.079-12.247-8.656-17.877-10.73l44.393 68.611c0.717 1.106 0.852 2.199 0.405 3.275-0.45 1.075-1.724 2.97-3.823 5.69-2.102 2.716-3.656 4.402-4.662 5.054-0.506 0.326-1.018 0.084-1.538-0.722l-4.294-7.298a390.422 390.422 0 0 0-8.4-13.645l-30.02-46.396c1.648 8.511 2.527 16.663 2.636 24.451 0.11 7.792-0.781 18.729-2.671 32.815l-4.596 0.187c1.195-24.213-4.332-51.868-16.587-82.958l-12.392 8.018c-2.621 1.696-4.623 3.35-6.01 4.96l-6.48-4.383c2.443-0.863 5.121-2.242 8.045-4.134l17.229-11.147-12.125-18.739c-5.605-8.664-9.473-14.309-11.602-16.935 5.221-2.091 9.622-3.686 13.197-4.787 3.577-1.098 5.807-1.682 6.689-1.755 0.884-0.069 1.456 0.097 1.716 0.499 0.522 0.808-0.396 3.257-2.747 7.351l17.112 26.448z m1.584-35.327c21.944 1.667 35.135 5.925 39.566 12.776 1.695 2.621 2.436 5.643 2.223 9.067-0.215 3.428-1.732 6.052-4.552 7.876-1.208 0.782-2.333 0.866-3.374 0.253-1.039-0.613-3.435-3.208-7.182-7.787-3.749-4.577-7.653-8.234-11.708-10.971-4.058-2.734-9.179-5.457-15.365-8.174l0.392-3.04z m58.287 27.461l-30.801-47.604c-3.911-6.045-6.275-9.587-7.094-10.632 13.689-5.567 21.058-7.548 22.1-5.938 0.719 1.11-0.166 3.611-2.648 7.502l31.289 48.36 15.869-10.267-0.009-10.285c0.111-0.93 0.419-1.558 0.925-1.884 0.604-0.391 4.211-0.615 10.818-0.676 6.608-0.058 10.189 0.341 10.742 1.196 0.555 0.857-0.316 3.602-2.609 8.228l33.344 51.533c4.433 6.85 7.09 10.85 7.974 11.993l2.596 3.68c0.521 0.805 0.473 1.838-0.142 3.094-0.618 1.257-2.012 3.301-4.179 6.134-2.171 2.832-3.809 4.608-4.915 5.324-0.707 0.458-1.549-0.071-2.525-1.582l-6.846-10.579-56.973 36.863c-2.018 1.305-3.484 2.682-4.4 4.134l-6.668-5.334c2.173-0.836 4.32-1.939 6.437-3.308l58.183-37.646-17.601-27.202-48.964 31.681c-1.915 1.239-3.432 2.65-4.551 4.231l-6.518-5.432c2.075-0.769 4.22-1.872 6.437-3.306l50.173-32.463-16.133-24.936-50.777 32.854c-2.018 1.305-3.534 2.715-4.553 4.231l-6.027-4.676c2.075-0.77 4.22-1.872 6.437-3.307l21.609-13.981z m4.741-72.53c15.059-1.023 23.045-0.832 23.957 0.579 0.457 0.706 0.027 1.59-1.283 2.653-1.314 1.064-2.135 2.061-2.464 2.987-0.329 0.929-0.729 2.904-1.204 5.924-3.131 19.465-6.07 34.801-8.82 46.012l-2.941-0.24c-0.331-24.367-2.747-43.673-7.245-57.915z"
            fill="#19be6b" p-id="1372"></path>
        </svg>
      </div>

      <div
        class="form-data-detail-container"
        :class="{'not-edit': !actionCanEdit}">

        <van-tabs
          v-model="tabActive"
          animated
          :ellipsis="false"
          @click="onClickTab">

          <template v-for="form in relateFormList">
            <van-tab :name="form.recordId" title="表单详情" v-if="form.recordId === 'dataDetail'" :key="form.recordId">

            <div class="form-detail-container">

              <div class="form-handle-content">
                <Fill :formSet="formSet">
                </Fill>
              </div>

              <template v-if="!$store.getters.isGuest">
                <div class="pagination" v-if="dataList && dataList.length">
                  <div
                    :style="{color: index === 0 ? '#959699' : '#333333'}"
                    @click="prevClick">
                    <van-icon name="arrow-left"/>
                    上一条
                  </div>
                  <div
                    :style="{color: index === dataList.length - 1 ? '#959699' : '#333333'}"
                    @click="nextClick">
                    下一条
                    <van-icon name="arrow"/>
                  </div>
                </div>
                <footer v-if="!isLink && showFooter" :style="{display: hiddenEdit && hiddenPrint && hiddenMore ? 'none' : 'flex'}">

                  <div v-if="!editStatus" class="default-state-container">
                    <div class="other-btn-container">
                      <div
                        v-if="actionCanEdit && !hiddenEdit"
                        class="btn-item"
                        @click="editForm">
                        <van-icon
                          size="22"
                          name="records">
                        </van-icon>
                        <div>修改</div>
                      </div>
                      <div
                        v-if="showPrint && !hiddenPrint"
                        class="btn-item"
                        @click="print">
                        <i class="iconfont icon-print"></i>
                        <div>打印</div>
                      </div>
                    </div>
                    <div class="more-btn"
                         v-if="!hiddenMore && showMore"
                         :style="viewButtonList.length ? computedStyle(viewButtonList[0]) : ''">
                      <div
                        class="main-btn"
                        @click="onClickMoreBtn">
                        {{viewButtonList.length ? viewButtonList[0].buttonName : '更多'}}
                      </div>
                      <div class="divider"></div>
                      <van-icon name="arrow-up" @click="showMoreBtn = true"/>
                    </div>
                  </div>

                  <div v-if="editStatus" class="edit-state-container">
                    <div
                      class="cancel-btn"
                      @click="cancelEdit">
                      取消
                    </div>
                    <div
                      class="save-btn"
                      @click="saveFormData">
                      保存
                    </div>
                  </div>

                  <van-action-sheet
                    class="handle-form-action"
                    :title="createInfoStr"
                    get-container="body"
                    v-model="showMoreBtn"
                    :actions="moreBtn"
                    cancel-text="取消"
                    close-on-click-action
                    @select="popupClick">
                  </van-action-sheet>

                  <!--打印-->
                  <print-template-dialog
                    v-if="formSet.isInit"
                    ref="printTemplateDialog"
                    :company-id="formSet.companyId"
                    :app-id="formSet.appId"
                    :form-id="formSet.formId"
                    :instance-id="instanceId"
                    scopeType="VIEW"
                    :data-id="viewId">
                  </print-template-dialog>
                </footer>
              </template>

              <template v-else-if="isLink || ($store.getters.isGuest && showPrint)">

                <footer style="height: 44px;">
                  <van-button
                    type="primary"
                    block
                    @click="print">
                    打印
                  </van-button>
                </footer>

                <!--打印-->
                <print-template-dialog
                  v-if="formSet.isInit"
                  ref="printTemplateDialog"
                  :company-id="formSet.companyId"
                  :app-id="formSet.appId"
                  :form-id="formSet.formId"
                  :instance-id="instanceId"
                  scopeType="VIEW"
                  :data-id="viewId">
                </print-template-dialog>
              </template>
            </div>
            </van-tab>

            <van-tab :name="form.recordId" title="动态" v-if="!isLink && form.recordId === 'dynamic' && !hiddenDynamic && (isShowLog || isDynamic || showApply || showComment)" :key="form.recordId">
              <template v-if="formSet.isInit">
                <form-flow-log
                  :form-id="formSet.formId"
                  :app-id="formSet.appId"
                  :instance-id="instanceId"
                  :step-id="stepId"
                  :formSet="formSet"
                  :showLog="isShowLog"
                  :showDynamic="isDynamic"
                  :showComment="showComment"
                  :showApply="showApply"
                  :viewId="viewId"
                  commentLocation="VIEW"
                  :tabActive="logTabActive"
                  :chargeUserConfig="chargeUserConfig"
                  :atUserConfig="atUserConfig">
                </form-flow-log>
              </template>
            </van-tab>

            <van-tab
              v-if="form.recordId !== 'dataDetail' && form.recordId !== 'dynamic' && !isLink"
              :key="form.recordId"
              :title="form.formName"
              :name="form.recordId">
              <template v-if="form.formType === FORM_TYPE_FORM">
                <div class="relate-form-data__table-container">

                  <FormDataView
                    :ref="`formDataView_${form.dataId}_${form.viewId}`"
                    :form-id="form.dataId"
                    :app-id="form.appId"
                    :view-id="form.viewId"
                    :view-type="form.viewType"
                    :instance-id="instanceId"
                    :active-relate-form="form"
                    :originalFormSet="formSet"
                    :has-add-form="Boolean(form.allowAddData)">
                  </FormDataView>
                </div>
              </template>

              <template v-if="form.formType === FORM_TYPE_DASHBOARD">
                <div class="relate-form-data__table-container">
                  <iframe
                    :src="dashSrc"
                    width="100%"
                    height="100%"
                    frameborder="0">
                  </iframe>
                </div>
              </template>
            </van-tab>
          </template>

          <template v-if="!isLink">
            <van-tab name="order" title="订单信息" v-if="orderList && orderList.length">
              <div class="form-order-list-container">
                <order-item
                  :orderList="orderList"
                ></order-item>
              </div>

            </van-tab>
          </template>

        </van-tabs>

      </div>
    </div>

    <div
      style="background-color: #ffffff; height: 100%;"
      v-else>
      <van-skeleton
        style="padding-top: 20px;"
        title
        :row="16">
      </van-skeleton>
    </div>
    <FormDataClashPopup ref="clashPopup" @fixComplete="fixComplete">
    </FormDataClashPopup>
  </div>
</template>

<script>
  import RyFormSet from "../RyForm"
  import Fill from "../RyForm/redact/Fill"
  import FormDataView from "./FormDataView";
  import PrintTemplateDialog from "./PrintTemplateDialog";
  import OrderItem from "./OrderItem";
  import {
    FORM_ITEM__SECTION,
    FORM_ITEM__TABLE,
    FORM_STATUS__FILL,
    FORM_STATUS__READ,
    FORM_TYPE__FILL, MESSAGE_TYPE_APPEND, MESSAGE_TYPE_DATA, MESSAGE_TYPE_SIGNATURE,
    FORM_TYPE_FORM,
    FORM_TYPE_DASHBOARD, FORM_ITEM__RELATE_RECORD, FORM_SUBMIT_ERROR, FORM_ITEM__CURRENT_VIEW_USER,
  } from "../RyForm/types"
  import {SUCCESS} from "../store/types"
  import {base64Decode, clone, formatDate, handleMessage, isNull} from "../../assets/js/Untis"
  import FormDataClashPopup from "./FormDataClashPopup"
  import FormFlowLog from "./FormFlowLog";
  import {FORM_VIEW_TYPE_DATA_HANDLE, FORM_VIEW_TYPE_DATA_VIEW} from "../../assets/types";

  export default {
    props: {
      viewType: {
        type: Number,
        default: 1
      },
      appId: {
        type: String,
        default: ''
      },
      formId: {
        type: String,
        default: ''
      },
      // 是否是外链
      isLink: {
        type: Boolean,
        default: false
      },
      // 进来默认执行按钮
      btnId: {
        type: String,
        default: ''
      },
      needBack: {
        type: Boolean,
        default: true
      }
    },
    components: {
      Fill,
      FormDataClashPopup,
      FormFlowLog,
      FormDataView,
      PrintTemplateDialog,
      OrderItem
    },
    data() {
      return {
        chargeUserConfig: {
          showContact: false
        },
        atUserConfig: {
          showContact: false
        },
        FORM_TYPE_FORM,
        FORM_TYPE_DASHBOARD,
        visible: false,
        tabActive: 'dataDetail',
        logTabActive: '',
        hiddenDynamic: 0,
        instanceId: '',
        stepId: '',
        viewId: '',
        formSet: new RyFormSet(),
        // 修改详情list
        editFieldList: [],
        // 当前表单详情（进度，流转日志...）
        currentFormDetail: null,
        // 展示流转日志中的修改详情
        showLogDetail: false,
        // 按钮列表按钮map
        btnOriginMap: {
          submit: '提交',
          agree: '同意',
          drafts: '暂存',
          reject: '拒绝',
          forward: '转交',
          repulse: '驳回',
          discard: '丢弃',
          revocation: '撤回',
          submitAndPrint: '提交并打印'
        },
        // 点击编辑表单，formset临时记录value，如果取消后，value应该复原
        formSetTempValue: null,

        isShowLog: false, // 是否显示流转日志
        isDynamic: false, // 是否显示数据动态
        showApply: false,
        showComment: false,
        readonlyFields: [], // 只读的空间Ids
        readonlyAll: false,
        allowDelete: '',

        editStatus: false,
        dataValues: {},
        viewButtonList: [],
        hiddenList: [],
        showFields: [],
        showButtonSheet: false,
        canEdit: 1,
        showMoreBtn: false,
        createInfoStr: '',

        relateFormList: [], // 关联表单
        dashKey: Math.random(),
        dashSrc: '',
        formKey: Math.random(),
        activeRelateForm: null,
        index: 0,
        dataList: [],

        hasEdit: true,

        viewSet: null,
        orderList: [],

        showPrint: false,
        archiveStatus: null,

        hiddenEdit: 0,
        hiddenPrint: 0,
        hiddenMore: 0
      };
    },
    computed: {

      // 折叠按钮
      moreBtn() {
        const btnArr = []
        if (this.viewButtonList.length) {
          btnArr.push(...this.viewButtonList.slice(-(this.viewButtonList.length - 1)))
        }

        if (this.isAdmin || this.allowCopy) {
          btnArr.push({
            name: '复制',
            color: '#333333'
          })
        }

        if (this.allowDelete === 'YES')  {
          btnArr.push({
            name: '删除',
            color: '#333333'
          })
        } else {
          if (this.isAdmin) {
            btnArr.push({
              name: '删除',
              color: '#333333'
            })
          }
        }
        if (this.isAdmin) {

          if (this.archiveStatus === 'YES') {
            btnArr.push({
              name: '取消归档',
              color: '#333333'
            })
          } else {
            btnArr.push({
              name: '归档',
              color: '#333333'
            })
          }
        }

        return btnArr
      },
      showMore() {
        return this.isAdmin || this.viewButtonList.length || this.allowCopy || this.allowDelete === 'YES'
      },
      showFooter() {
        return (!this.hiddenMore && this.showMore) ||
          (this.showPrint && !this.hiddenPrint) ||
          (this.actionCanEdit && !this.hiddenEdit)
      },
      actionCanEdit() {
        return (this.isAdmin || this.canEdit) && this.archiveStatus === 'NO' && this.readonlyAll === 'NO'
      },

      isAdmin() {
        const adminInfo = this.$store.getters.adminInfo
        const currentApp = this.$store.getters.currentApp || {canEdit: 0}
        return adminInfo && (adminInfo.creator || adminInfo.topAdmin || currentApp.canEdit)
      },
    },
    methods: {
      open({
             instanceId,
             stepId,
             viewId,
             hiddenFieldList,
             showFields,
             canEdit,
             index,
             isShowLog,
             isDynamic,
             showApply,
             showComment,
             hiddenDynamic = 0,
             readonlyFields = [],
             readonlyAll = 'NO',
             dataList, tabActive, logTabActive, allowDelete, hiddenEdit = 0, hiddenPrint = 0, hiddenMore = 0}) {
        this.formSet = new RyFormSet()
        this.instanceId = instanceId
        this.stepId = stepId
        this.viewId = viewId
        this.hiddenList = hiddenFieldList
        this.showFields = showFields
        this.visible = true
        this.editStatus = false
        this.dataValues = {}
        this.viewButtonList = []
        this.index = index
        this.dataList = dataList
        this.canEdit = canEdit
        this.isShowLog = isShowLog
        this.isDynamic = isDynamic
        this.allowDelete = allowDelete
        this.tabActive = tabActive || 'dataDetail'
        this.logTabActive = logTabActive || ''
        this.hiddenDynamic = hiddenDynamic
        this.hiddenEdit = hiddenEdit
        this.hiddenPrint = hiddenPrint
        this.hiddenMore = hiddenMore
        if (!isNull(showApply)) this.showApply = showApply
        if (!isNull(showComment)) this.showComment = showComment
        this.readonlyFields = readonlyFields
        this.readonlyAll = readonlyAll
        this.fetchOrderList()
        this.getFormData()
        this.fetchFormFillPermission()

        if (this.$store.state.userId === 1) {
          this.$store.dispatch('actionFetchFormViewOutDetail', {
            companyId: this.$store.state.companyId,
            appId: this.$store.state.appId,
            formId: this.formId,
            viewId: this.viewId
          }).then(resultObject => {
            this.viewSet = resultObject
            this.canEdit = !resultObject.forbiddenEdit
          }).catch(console.error)
        } else {
          this.$store.dispatch('actionFetchFormViewDetail', {
            formId: this.formId,
            viewId: this.viewId
          }).then(resultObject => {
            this.viewSet = resultObject
            this.canEdit = !resultObject.forbiddenEdit
          }).catch(console.error)
        }

      },

      fetchOrderList() {
        if (this.instanceId) {
          this.$store.dispatch('actionCompanyPaymentApplyList', {
            instanceId: this.instanceId
          }).then(res => {
            this.orderList.splice(0, this.orderList.length, ...res)
          }).catch(console.error)
        }
      },
      // 已有value
      existValueOpen({values, stepId, instanceId,viewId, hasEdit}) {
        this.hasEdit = hasEdit
        this.formSet = new RyFormSet()
        this.editStatus = false
        this.instanceId = instanceId
        this.stepId = stepId
        this.viewId = viewId
        this.dataValues = {}
        this.getFormData(values)
        this.fetchFormFillPermission()
      },
      getFormData(values) {

        this.$store.dispatch('actionMergeStructure', {
          appId: this.appId,
          formId: this.formId,
          formType: FORM_TYPE__FILL,
          viewType: this.viewType,
          viewId: this.viewId,
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              return resultObject
            } else {
              throw new Error(`${status}: ${info}`)
            }
          })
          .then(({structureInfo, permissionInfo, detailInfo, pluginList, bothRelateList, displayList, widthInfo}) => {

            this.formSet.status = FORM_STATUS__READ

            this.formSet.setStructure(structureInfo)
            this.formSet.setPermission(permissionInfo.permissionList)
            this.formSet.setConf(detailInfo)
            this.formSet.setPlugin(pluginList)
            this.formSet.setBothRelate(bothRelateList)
            this.formSet.setDisplayRule(displayList)
            this.formSet.setWidth(widthInfo)

            this.relateFormList.splice(0, this.relateFormList.length)
            
            const view = detailInfo.viewList.filter(view => view.dataId === this.viewId)[0]
            const showIdList = view ? view.showIdList : []
            if(detailInfo.openMobileCustomSort === 'YES'){
              detailInfo.mobileCustomSortList.forEach(form => {
                if (showIdList.includes(form.recordId)) {
                  if (!form.viewId || form.viewId === 'dataHandle') {
                    form.viewId = 'dataHandle'
                    form.viewType = FORM_VIEW_TYPE_DATA_HANDLE
                  } else {
                    form.viewType = FORM_VIEW_TYPE_DATA_VIEW
                  }
                  form.formName = form.showName || form.formName
                  this.relateFormList.push(form)
               }else if(form.recordId==='dataDetail' || form.recordId === 'dynamic'){
                this.relateFormList.push(form)
               }
              })
            }else{
              this.relateFormList.push({recordId: 'dataDetail'})
              this.relateFormList.push({recordId: 'dynamic'})  
              detailInfo.relateFormList.forEach(form => {
                if (showIdList.includes(form.recordId)) {
                  if (!form.viewId || form.viewId === 'dataHandle') {
                    form.viewId = 'dataHandle'
                    form.viewType = FORM_VIEW_TYPE_DATA_HANDLE
                  } else {
                    form.viewType = FORM_VIEW_TYPE_DATA_VIEW
                  }
                  form.formName = form.showName || form.formName
                  this.relateFormList.push(form)
               }
              })
            }
            this.tabActive = this.relateFormList[0] ? this.relateFormList[0].recordId : 'dataDetail'
            this.formSetFieldHandle()

            if (this.instanceId) {
              this.formSet.instanceId = this.instanceId
              return this.getFormValues()
            } else if (values) {
              this.dataValues = values
              this.stepId = values['stepId']
              this.formSet.setValues(values)
              this.fetchOverview()
            }
          })
          .then(() => {
            if (this.btnId) {
              const btn = this.viewButtonList.filter(btn => btn.buttonId === this.btnId)[0]
              if (btn) this.onClickBtn(btn)
            }

            const currentUserField = []
            Object.values(this.formSet.fields).forEach(field => {
              if (field.type === FORM_ITEM__CURRENT_VIEW_USER) {
                currentUserField.push(field)
              }
            })
            if (currentUserField.length) {
              return this.$store.dispatch('actionMemberInfo', {
                companyId: this.formSet.companyId,
                userIdList: [this.$store.getters.userId]
              }).then(res => {
                if (res && Object.keys(res).length) {
                  currentUserField.forEach(field => {
                    const info = res[this.$store.getters.userId]
                    field.value.depart.push(...info.deptIdList)
                    field.value.role.push(...info.roleIdList)
                    field.value.externalTag.push(...info.tagList)
                  })
                }
                this.formSet.computeDisplayResults()
              })
            }
          })
          .then(() => {
            if (this.instanceId && this.formSet.hasRealTimeDataField()) {
              return this.$store.dispatch('actionFormRealTimeDataFieldData', {
                appId: this.formSet.appId,
                formId: this.formSet.formId,
                data: this.formSet.getValues()
              })
                .then(values => {
                  if (values && this.dataValues) {
                    Object.keys(values).forEach(key => {
                      if (this.dataValues.hasOwnProperty(key)) {
                        this.dataValues[key] = values[key]
                      }
                    })
                  }
                  this.formSet.setValues(values)
                })
            }
          })
          .then(() => {
            this.formSet.stepId = this.stepId

            return Promise.all([
              this.$Socket.init(),
              this.$store.dispatch('actionTopicGet', {
                appId: this.appId,
                formId: this.formId,
              })
            ])
          })
          .then(([init, res]) => {
            this.formSet.tmpTopic = res.tmpTopic
            this.$Socket.subscribe(res.tmpTopic, ({messageType, context, content}) => {
              if (messageType === this.$RySocket.MESSAGE_TYPE_PLUGIN_RESULT) {
                const {resultType, showMsg} = content
                if (showMsg && resultType === 'SUCCESS') {
                  this.$toast.success(showMsg)
                } else if (showMsg && resultType === 'FAIL') {
                  this.$toast.fail(showMsg)
                }
                const changeFlowEvent = new CustomEvent('PLUGIN_RESULT_RECEIVED', {detail: {context, content}})
                document.dispatchEvent(changeFlowEvent)
                return
              }
              handleMessage(this.formSet, {messageType, context, content})
            })

            return this.$store.dispatch('actionPrintTempList', {
              companyId: this.formSet.companyId,
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              dataId: this.viewId,
              scopeType: 'VIEW'
            })
          })
          .then(res => {
            this.showPrint = Boolean(res && ((res.uploadList && res.uploadList.length) ||
              (res.pdfTemplateList && res.pdfTemplateList.length) ||
              (res.wordTemplateList && res.wordTemplateList.length)))
          })
          .then(() => {
            this.formSet.isInit = true
          })
          .catch(err => {
            console.log(err)
          })
      },

      // apply detail
      getFormValues() {
        return this.$store.dispatch('actionFetchFormViewDataDetail', {
          formId: this.formSet.formId,
          instanceId: this.instanceId,
          accessType: 'VIEW',
          appId: this.formSet.appId,
          viewId: this.viewId,
          stepId: this.stepId
        }).then(({data, flowButtonList, viewButtonList}) => {
          this.dataValues = data
          this.formSet.setValues(data)
          viewButtonList.forEach(btn => {
            this.viewButtonList.push({
              name: btn.buttonName,
              color: '#333333',
              ...btn
            })
          })
          this.stepId = data['stepId']
          this.fetchOverview()
          this.archiveStatus = data['archiveStatus'] || 'NO'
        })

      },

      fetchOverview() {
        this.$store.dispatch('actionFetchFormApplyOverview', {
          companyId: this.$store.state.companyId,
          formId: this.formId || this.$store.state.formId,
          appId: this.appId || this.$store.state.appId,
          stepId: this.stepId,
          instanceId: this.instanceId
        }).then(info => {
          this.currentFormDetail = info
          let time = ''
          if (info.flowLogList && info.flowLogList.length > 0) {
            time = this.formatDate(info.flowLogList[0].handleTime)
          }
          this.createInfoStr = `${info.userName} 创建于${time}`
        })
      },

      fetchFormFillPermission() {
        this.$store.dispatch('actionFormFillPermission', {
          appId: this.appId || this.$store.getters.currentAppId,
          formId: this.formId || this.$store.getters.currentFormId
        }).then(res => {
          this.hasFillForm = res.hasPer
        }).catch(console.error)
      },

      // 处理字段隐藏显示
      formSetFieldHandle() {
        if (this.showFields && this.showFields.length) {
          Object.values(this.formSet.fields).forEach(field => {
            if (field.type !== FORM_ITEM__SECTION && field.parent.type !== FORM_ITEM__TABLE) {
              if (this.showFields.includes(field.dataId)) {
                field.hidden = 0
              } else {
                field.hidden = 1
              }
            }
          })
          // 处理子表单隐藏
          // Object.values(this.formSet.fields).forEach(field => {
          //   if (field.type === FORM_ITEM__TABLE) {
          //     let hidden = 1
          //     field.children.forEach(item => {
          //       if (item.hidden === 0) {
          //         hidden = 0
          //       }
          //     })
          //     field.hidden = hidden
          //   }
          // })
        }

        if (this.readonlyAll === 'YES') {
          Object.values(this.formSet.fields).forEach(field => {
            if (field.type !== FORM_ITEM__SECTION) {
              field.edit = 0
            }
          })
        } else {
          if (this.readonlyFields && this.readonlyFields.length) {
            Object.values(this.formSet.fields).forEach(field => {
              if (this.readonlyFields.includes(field.dataId)) {
                field.edit = 0
              }
            })
          }
        }
      },
      // 时间转换方法
      formatDate(d) {
        return formatDate(d)(`yyyy-MM-dd HH:mm:ss`)
      },
      // btn样式
      computedStyle(opt) {
        return {
          backgroundColor: opt.buttonColor,
          borderColor: opt.buttonColor
        }
      },
      // 点击查看流转日志中修改详情
      onClickLogDetail(item) {
        this.editFieldList = item.editFieldList
        this.logDetailKey = Math.random()
        this.showLogDetail = true
      },

      // 对比修改内容的表单内容对比table渲染函数
      valueFormatter(fieldId, value) {
        const opts = {
          depList: this.$store.getters.depListMap,
          roleList: this.$store.getters.roleListMap,
          userList: this.$store.getters.userListMap
        }
        return this.formSet.valueToString(fieldId, value, opts)
      },

      // 保存修改数据
      saveFormData({visible = false, data = this.formSet.getValues(), oldChangeList = [], execute}, callback) {
        const toast = this.$toast.loading({message: '加载中...'})
        const remoteChangeList = this.dataValues['changeList'] || []
        const newChangeList = remoteChangeList.concat(oldChangeList)
        const remoteChangeMap = {}
        newChangeList.forEach(item => {
          remoteChangeMap[item.fieldId] = item
        })
        const changeList = this.formSet.getModified().map(field => {
          return {
            fieldId: field.dataId,
            lastVersion: remoteChangeMap[field.dataId] ? remoteChangeMap[field.dataId].lastVersion : 0
          }
        })

        const relateHandleMap = {}
        Object.keys(this.formSet.fields).forEach(key => {
          const field = this.formSet.fields[key]
          if (field.type === FORM_ITEM__RELATE_RECORD) {
            relateHandleMap[key] = {
              addInstanceList: field.addInstanceList, //新增的实例
              deleteInstanceList: field.deleteInstanceList //删除的实例
            }
          }
        })

        // 清空字段错误信息
        this.formSet.clearError()

        let uri = 'actionSaveFormData'
        if (execute) {
          uri = 'actionExecuteSaveFormData'
        } else {
          uri = 'actionSaveFormData'
        }

        this.$store.dispatch(uri, {
          appId: this.appId,
          formId: this.formId || this.$store.state.formId,
          instanceId: this.instanceId,
          viewId: this.viewId,
          viewGroupId: this.viewGroupId,
          data: data,
          operateId: this.fetchOperateId(),
          refreshType: 0,
          changeList: changeList,
          relateHandleMap,
          showFieldIdList: this.formSet.fetchShowFieldIdList()
        }).then(({status, resultObject, info}) => {

          if (status === SUCCESS) {
            if (visible) {
              // 如果是保存不关闭当前dialog，就需要重新赋值changList
              const lastChangeList = this.dataValues['changeList'] || []
              lastChangeList.splice(0, lastChangeList.length, ...resultObject.changeList)

              // 重新刷新数据，关联表单，数据动态

              if (callback) {
                callback()
              }
            }

            if (resultObject.changeSuc) {

              if (this.$refs.clashPopup) this.$refs.clashPopup.open({
                formSet: this.formSet,
                clashData: resultObject.applyInstance,
                changeList: resultObject.changeList,
                context: {
                  visible: visible,
                  type: 'applyUpdate'
                }
              })

            } else {
              if (!visible) {
                this.$emit('saveDataComplete', this.viewId)
                this.$toast.success('保存成功')
              }
              this.formSetTempValue = null
              this.cancelEdit()
              // this.visible = visible
            }
          } else if (status === FORM_SUBMIT_ERROR && info) {
            // 表单字段校验未通过
            const errInfo = JSON.parse(base64Decode(info))
            if (errInfo) {
              this.formSet.setError(errInfo)
              this.$dialog.alert({
                title: '提交验证失败',
                message: errInfo.errorMessage,
              }).then(() => {
                // on close
              });
            }
          } else {
            if (info) {
              this.$toast.fail(info)
            }
          }

        }).catch(console.error)
          .finally(() => {
            toast.clear()
          })
      },

      // 处理冲突完成
      fixComplete(opt) {
        const {
          data,
          changeList,
          context
        } = opt
        this.saveFormData({
          visible: context.visible,
          oldChangeList: changeList,
          data
        })
      },

      fetchOperateId() {
        return `${this.$store.state.userId}${(new Date()).valueOf()}`
      },

      // 打印
      print() {
        if (this.$refs.printTemplateDialog[0]) {
          this.$refs.printTemplateDialog[0].open()
        }
      },

      editForm() {
        if (!this.hasEdit) {
          this.$toast.fail('该表单数据不允许修改')
          return
        }
        if (this.actionCanEdit) {
          this.formSet.status = FORM_STATUS__FILL
          this.formSetTempValue = clone(this.formSet.getValues())
          this.editStatus = true
        } else {
          this.$toast.fail('您没有权限修改该表单')
        }
      },
      // 取消编辑
      cancelEdit() {
        this.formSet.status = FORM_STATUS__READ
        if (this.formSetTempValue) {
          this.formSet.setValues(this.formSetTempValue)
        }
        this.editStatus = false
      },
      // 点击button回调
      onClickBtn(btn) {

        const toast = this.$toast.loading('加载中...')
        this.$store.dispatch('actionFetchButtonConfirmCheck', {
          formId: this.formId,
          viewId: this.viewId,
          instanceId: this.instanceId,
          buttonId: btn.buttonId
        }).then(({status, resultObject, info}) => {
          if (status === FORM_SUBMIT_ERROR && info) {
            // 表单字段校验未通过
            const errInfo = JSON.parse(base64Decode(info))
            if (errInfo) {
              this.$dialog.alert({
                title: '提交验证失败',
                message: errInfo.errorMessage,
              }).then(() => {
                // on close
              });
            }
          } else {

            this.saveFormData({
              execute: true,
              visible: true
            }, () => {
              if (btn.executeType === 0 || btn.executeType === 3) {
                this.buttonConfirm(btn, true)
              } else if (btn.executeType === 1) {
                this.$dialog.confirm({
                  title: '提示',
                  message: btn.confirmShowTitle,
                  confirmButtonText: btn.confirmButton,
                  cancelButtonText: btn.cancelButton,
                }).then(() => {
                  // on confirm
                  this.buttonConfirm(btn, true)
                }).catch(() => {
                  // on cancel
                })
              } else if (btn.executeType === 2) {
                const toast = this.$toast.loading({message: '加载中...'})
                this.$store.dispatch('actionViewButtonApplyData', {
                  appId: btn.startFormInfo.appId,
                  formId: btn.startFormInfo.formId,
                  viewId: this.viewId,
                  instanceId: this.instanceId,
                  buttonId: btn.buttonId
                }).then(res => {
                  sessionStorage.setItem('execute', JSON.stringify({
                    formId: this.formId,
                    viewId: this.viewId,
                    instanceId: this.instanceId,
                    buttonId: btn.buttonId
                  }))
                  return this.$store.dispatch('reqNodeSave', {
                    appId: btn.startFormInfo.appId,
                    formId: btn.startFormInfo.formId,
                    formSetValue: res
                  })
                })
                  .then(res => {
                    if (this.btnId) {
                      location.replace(`${location.origin}${this.$MINIAPP_BASE_PATH}/#/formInput?key=${res.nodeKey}`)
                    } else {
                      this.$router.push({
                        name: 'formInput',
                        query: {
                          key: res.nodeKey
                        }
                      })
                    }
                  })
                  .catch(console.error)
                  .finally(() => {
                    toast.clear()
                  })
              }
            })
          }
        }).catch(console.error)
          .finally(() => {
            toast.clear()
          })

      },

      buttonConfirm(btn, exit) {
        this.$store.dispatch('actionFetchButtonConfirm', {
          formId: this.formId,
          viewId: this.viewId,
          instanceId: this.instanceId,
          buttonId: btn.buttonId
        }).then(res => {
          this.$toast.success('操作成功')
          if (exit) {
            this.$emit('saveFormDataComplete', this.viewId)
          }
        }).catch(console.error)
      },

      popupClick(info) {
        if (info.name === '复制') {
          if (!this.hasFillForm) {
            this.$toast.fail('您没有该操作权限')
          } else {
            this.$dialog.confirm({
              title: '提示',
              message: '确定复制本条数据并打开填写表单?',
            })
              .then(() => {
                // on confirm
                const toast = this.$toast.loading({
                  message: '加载中...'
                })
                this.$store.dispatch('reqNodeSave', {
                  formSetValue: this.formSet.getValues()
                }).then(res => {
                  this.$router.push({
                    name: 'formInput',
                    query: {
                      key: res.nodeKey
                    }
                  })
                })
                  .catch(console.error)
                  .finally(() => {
                    toast.clear()
                  })
              })
              .catch(() => {
                // on cancel
              });
          }

        } else if (info.name === '删除') {
          if (!this.isAdmin && this.allowDelete !== 'YES') {
            this.$toast.fail('您没有该操作权限')
          } else {
            this.$dialog.confirm({
              title: '提示',
              message: '确定删除本条数据?',
            })
              .then(() => {
                // on confirm
                const toast = this.$toast.loading({
                  message: '删除中...'
                })
                this.$store.dispatch('actionViewBatchDelete', {
                  appId: this.appId,
                  formId: this.formId || this.$store.state.formId,
                  viewId: this.viewId,
                  deleteType: 'CHOOSE',
                  instanceIdList: [this.instanceId]
                }).then(() => {
                  this.$toast.success('删除成功')
                  if (this.needBack) {
                    this.$router.go(-1)
                  } else {
                    this.$emit('deleteComplete')
                  }
                }).catch(err => {
                  console.error(err)
                }).finally(() => {
                  toast.clear()
                })
              })
              .catch(() => {
                // on cancel
              });
          }

        } else if (info.name === '归档') {
          this.$dialog.confirm({
            title: '提示',
            message: '归档操作后,该数据将不可修改。是否继续?',
          })
            .then(() => {
              // on confirm
              const toast = this.$toast.loading({
                message: '归档中...'
              })
              this.$store.dispatch('actionBatchArchive', {
                appId: this.appId,
                archiveType: 'CHOOSE',
                formId: this.formId,
                dataType: 'VIEW',
                viewId: this.viewId,
                instanceIdList: [this.instanceId],
                handleType: 'ARCHIVE'
              }).then(() => {
                this.archiveStatus = 'YES'
                this.$toast.success('归档成功')
              }).catch(err => {
                console.error(err)
              }).finally(() => {
                toast.clear()
              })
            })
            .catch(() => {
              // on cancel
            });
        } else if (info.name === '取消归档') {
          const toast = this.$toast.loading()
          this.$store.dispatch('actionBatchArchive', {
            appId: this.appId,
            archiveType: 'CHOOSE',
            formId: this.formId,
            dataType: 'VIEW',
            viewId: this.viewId,
            instanceIdList: [this.instanceId],
            handleType: 'UNARCHIVE'
          }).then(() => {
            this.archiveStatus = 'NO'
            this.$toast.success('取消归档成功')
          }).catch(err => {
            console.error(err)
          }).finally(() => {
            toast.clear()
          })
        } else {
          this.onClickBtn(info)
        }
        this.showMoreBtn = false
      },

      onClickMoreBtn() {
        if (this.viewButtonList.length) {
          this.popupClick(this.viewButtonList[0])
        } else {
          this.showMoreBtn = true
        }
      },

      // 打印
      printClick(info) {
        this.$store.dispatch('actionFormLinkPrintTemp', {
          companyId: this.formSet.companyId,
          appId: this.formSet.appId,
          formId: this.formSet.formId,
          itemId: info.id,
          instanceId: this.instanceId
        }).then(res => {
          return this.$store.dispatch('actionNodeSave', {
            companyId: res.companyId,
            exportId: res.exportId,
            type: 'PRINT_RESULT',
            pageTitle: info.name
          })
        })
          .then(res => {
            const aEle = document.createElement('a')
            if (process.env.NODE_ENV === 'production') {
              aEle.href = `${location.origin}${this.$MINIAPP_BASE_PATH}/#/print_result?key=${res.nodeKey}`
            } else {
              aEle.href = `http://192.168.50.35:8080/#/print_result?key=${res.nodeKey}`
            }
            aEle.target = '_blank'
            aEle.click()
          })
          .catch(console.error)
      },

      onClickTab(name) {
        if (name === 'dataDetail' || name === 'dynamic' || name === 'order') {
          return
        }
        this.activeRelateForm = this.relateFormList.filter(form => form.recordId === name)[0]
        if (this.activeRelateForm.formType === FORM_TYPE_FORM) {
          this.formKey = Math.random()
          const key = `formDataView_${this.activeRelateForm.dataId}_${this.activeRelateForm.viewId}`
          if (this.$refs[key] && this.$refs[key][0]) {
            this.$refs[key][0].restartRequest()
          }
        } else if (this.activeRelateForm.formType === FORM_TYPE_DASHBOARD) {
          this.dashSrc = ``
          const toast = this.$toast.loading({message: '加载中...'})
          this.$store.dispatch('actionNodeSave', {
            companyId: this.$store.getters.currentCompanyId,
            userId: this.$store.getters.userId,
            appId: this.activeRelateForm.appId,
            dashboardId: this.activeRelateForm.dataId,
            token: this.$store.state.token,
            isFormRelate: 1,
            dashFilterList: this.activeRelateForm.dashFilterList,
            env: this.$store.getters.env,
            fields: Object.values(this.formSet.fields).map(field => {
              return {
                dataId: field.dataId,
                type: field.type,
                value: field.value
              }
            })
          })
            .then(res => {
              this.dashKey = Math.random()
              if (process.env.NODE_ENV === 'production') {
                this.dashSrc = `${location.origin}${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
              } else {
                this.dashSrc = `http://127.0.0.1:8082/#/dashboard?key=${res.nodeKey}`
              }
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }
      },

      // 上一条数据
      prevClick() {
        if (this.index === 0) {
          return
        }
        this.index--
        this.open({
          instanceId: this.dataList[this.index].instanceId || this.dataList[this.index].item.instanceId,
          stepId: this.stepId,
          viewId: this.viewId,
          showFields: this.showFields,
          index: this.index,
          dataList: this.dataList,
          canEdit: this.canEdit
        })
      },
      // 下一条数据
      nextClick() {
        if (this.index === this.dataList.length - 1) {
          return
        }
        this.index++
        this.open({
          instanceId: this.dataList[this.index].instanceId || this.dataList[this.index].item.instanceId,
          stepId: this.stepId,
          viewId: this.viewId,
          showFields: this.showFields,
          index: this.index,
          dataList: this.dataList,
          canEdit: this.canEdit
        })
      },
    }
  };
</script>

<style lang="less">

  .form-data-view-container {
    height: 100%;


    .form-view-data-popup-container {
      box-sizing: border-box;
      overflow: hidden;
      height: 100%;
      position: relative;

      .archive-status {
        position: absolute;
        top: 5px;
        left: 16px;
        width: 40px;
        height: 40px;
        z-index: 10;
      }

      .form-data-detail-container {
        height: 100%;

        .van-tabs {
          height: 100%;
          border-bottom: 1px solid #e6e6e6;

          .van-tabs__content {
            height: 100%;

            .van-tab__pane {
              height: 100%;
            }
          }
        }

        .form-order-list-container {
          height: calc(100% - 44px);
          overflow: auto;
        }

        .form-detail-container {
          height: calc(100% - 44px);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          position: relative;

          .form-handle-content {
            flex: 1;
            -webkit-overflow-scrolling: touch;
            overflow-y: auto;
          }

          .pagination {
            height: 44px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px;
            font-size: 14px;
            background-color: rgba(255, 255, 255, 0.8);
            border-bottom: 1px solid #e6e6e6;
            border-top: 10px solid #F6F6F6;

            > div {
              color: #333333;
              display: flex;
              align-items: center;
            }
          }

          > footer {
            display: flex;
            box-sizing: border-box;
            border-top: 1px solid #ebedf0;
            height: 54px;
            width: 100%;
            background-color: #FFFFFF;
            position: relative;
            bottom: 0;
            z-index: 3;

            .default-state-container {
              display: flex;
              height: 100%;
              width: 100%;

              .more-btn {
                width: 160px;
                height: 40px;
                display: flex;
                align-items: center;
                color: #fff;
                font-size: 14px;
                border-radius: 4px;
                border: 1px solid #4A66FA;
                background-color: #4A66FA;
                margin: 5px;

                .main-btn {
                  width: 120px;
                  text-align: center;
                }

                .divider {
                  width: 1px;
                  height: 30px;
                  margin: 0 10px 0 5px;
                  background-color: #ffffff;
                }
              }

              .other-btn-container {
                flex: 1;
                display: flex;
                justify-content: space-around;
                align-items: center;

                .btn-item {
                  font-size: 14px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  color: #7F8389;

                  > div {
                    margin-top: 5px;
                    font-size: 12px;
                  }

                  i {
                    font-size: 20px;
                  }
                }
              }
            }

            .edit-state-container {
              height: 100%;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .cancel-btn {
                width: 40%;
                height: 40px;
                margin-right: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333333;
                font-size: 14px;
                border-radius: 4px;
                background-color: #ffffff;
                border: 1px solid #e6e6e6;
              }

              .save-btn {
                width: 40%;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 14px;
                border-radius: 4px;
                border: 1px solid #4A66FA;
                background-color: #4A66FA;
              }
            }
          }
        }

      }

      .relate-form-data__table-container {
        width: 100%;
        height: calc(100% - 44px);
      }

      .not-edit {
        height: 100%;
      }
    }
  }


  .handle-form-action {
    .van-action-sheet__header {
      font-size: 12px;
      color: #7F8389;
    }

    .van-action-sheet__content {

      .van-action-sheet__item {
        border-bottom: 1px solid #f6f6f6;
      }
    }
  }
</style>
